export interface Call {
    id?: number;
    recordingSid: string;
    callSid: string;
    externalNumber: string;
    outbound: boolean;
    initiated: Date;
    agent: string;
    fileName: string;
    duration: number;
    patientId: number;
    disposition: string;

    // Patient information (from JOIN)
    patientFirstName?: string;
    patientLastName?: string;

    // Audit-related properties
    auditQuestionSetId?: number;
    auditCompletedBy?: string;
    auditCompletedAt?: Date;
}

export class Call {
    constructor(obj?: Call) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
